import { z } from "zod";

const paymentStatus = z
  .enum([
    "NEW",
    "PENDING",
    "PENDING_REPEATING",
    "PENDING_REPEATING_RETRY",
    "COMPLETED",
    "FAILED",
    "PARTIAL",
    "CANCELLED",
  ])
  .optional();

export const serverResponse = z.object({
  transactionLink: z.string().optional(),
  status: paymentStatus,
});

export type IPaymentStatus = z.infer<typeof paymentStatus>;
